import styled from "styled-components";
import colors from "../../../../../core/styles/colors";
import sizes from "../../../../../core/styles/sizes";

export const Form = styled.form`
  width: 100%;
  min-height: inherit;
  display: flex;
  flex-direction: column;

  @media all and (${sizes.mobile}) {
    height: calc(100% - 110px);
    padding: 80px 0 30px 0;
    background: ${colors.white.general};

    .formContent {
      height: max-content !important;
    }
  }
`;

export const SuccessText = styled.span`
  color: ${colors.green.general};
`;

export const ErrorText = styled.span`
  color: ${colors.red.general};
`;

export const Actions = styled.div`
  margin: 0 auto;
  max-width: 200px;
  width: 100%;

  button {
    width: 100%;
  }

  @media all and (${sizes.mobile}) {
    max-width: calc(100% - 32px);
  }
`;
